function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/InstallApi";
import IntlMessage from '../commons/Intl';
import { Actions, Install } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    var origin = location.origin;

    if (origin === undefined) {
      origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
    }

    _this.state = {
      PcAppUrl: origin + "/Files/Installers/Pc/WHITEROOM.zip",
      VRPlusAppUrl: origin + "/Files/Installers/Pc/WHITEROOMVRPlus.zip",
      UsePcVrOption: false
    };
    Api.GetOrganizationOptions(function (options) {
      if (options != null) {
        _this.setState({
          UsePcVrOption: options.UsePcVrOption
        });
      }
    });
    return _this;
  }
  /**
   * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
   */


  _createClass(MainComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
      this.handleScroll();
    }
    /**
     * Componentが更新された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * スクロールイベント処理
     */

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      setTimeout(function () {
        var _$;

        window.scrollTo(0, 0);
        (_$ = $('#loading-overlay')) === null || _$ === void 0 ? void 0 : _$.hide();
      }, 500);
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        id: "normal",
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        width: "60",
        height: "60",
        src: "/assets/img/install_icon_side.svg"
      }), /*#__PURE__*/React.createElement("h2", null, intl.format(Install.Title))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("label", {
        className: "install__title"
      }, intl.format(Install.PcTitle))), this.state.UsePcVrOption && /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("label", {
        className: "install__title"
      }, intl.format(Install.VRPlusTitle)))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          maxWidth: "30%"
        },
        src: "/assets/img/Devices_Pc.png"
      })), this.state.UsePcVrOption && /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          maxWidth: "30%"
        },
        src: "/assets/img/Devices_Pc.png"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-3",
        style: {
          display: "flex",
          placeContent: "center",
          marginBottom: "10px"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: this.state.PcAppUrl
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/icon_Download-1.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Actions.Download))))), this.state.UsePcVrOption && /*#__PURE__*/React.createElement("div", {
        className: "col-3",
        style: {
          display: "flex",
          placeContent: "center",
          marginBottom: "10px"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: this.state.VRPlusAppUrl
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/icon_Download-1.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Actions.Download)))))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("label", {
        className: "install__message"
      }, intl.format(Install.PcApp))), this.state.UsePcVrOption && /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("label", {
        className: "install__message"
      }, intl.format(Install.VRPlusApp)))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("a", {
        href: "https://whiteroom.business/support/?p=7119",
        target: "_blank",
        className: "install__link"
      }, "https://whiteroom.business/support/?p=7119")), this.state.UsePcVrOption && /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("a", {
        href: "https://whiteroom.business/support/?p=8288",
        target: "_blank",
        className: "install__link"
      }, "https://whiteroom.business/support/?p=8288"))))));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param environment 環境種別
 */


export default function (el, common, environment) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common
  }), el);
}